import apiClient from '../../../common/services/apiClient';
import { createQueryString, convertJsonToQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_TRANSACTIONS: 'FETCH_TRANSACTIONS',
  FETCH_PENDING_TRANSACTIONS: 'FETCH_PENDING_TRANSACTIONS',
  DELETE_EXTERNAL_TRANSACTION: 'DELETE_EXTERNAL_TRANSACTION',
  FETCH_REPORT: 'FETCH_REPORT',
};

export default {
  fetchTransactions: options => {
    return apiClient.get(`/transactions?${convertJsonToQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_TRANSACTIONS,
    });
  },
  fetchPendingTransactions: options => {
    return apiClient.get(`/transactions/external/pending?${convertJsonToQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_PENDING_TRANSACTIONS,
    })
  },
  deleteExternalTransaction: id => {
    return apiClient.delete(`/transactions/external/pending/${id}`, {
      apiCallId: apiCallIds.DELETE_EXTERNAL_TRANSACTION,
    })
  },
  fetchTransactionsPreview: payload => {
    return apiClient.get(`/transactions/preview/${payload.accountId}?${convertJsonToQueryString(payload.options)}`, {
      apiCallId: apiCallIds.FETCH_PENDING_TRANSACTIONS,
    })
  },
  fetchTransactionsSummary: payload => {
    return apiClient.get(`/transactions/summary/${payload}`, {
      apiCallId: apiCallIds.FETCH_TRANSACTIONS_SUMMARY,
    })
  },
  fetchReport: () => {
    return apiClient.get(`/transactions/reportJob`, {
      apiCallId: apiCallIds.FETCH_REPORT,
    })
  }
};



// WEBPACK FOOTER //
// ./src/features/transactions/api/index.js